<template lang="pug">
	.product-feed
		.product-feed-url
			span.split-input
				span.split-title.text-muted Feed url
				input.form-control.form-control-sm(type="text" :value="settingValue['feedUrl']" v-on:change="setFeedUrl($event.target.value)")
		.product-feed-offers
			.product-feed-offer(v-for="offer in settingValue.offers" :key="offer.id" @click="expandOffer(offer.offer_id, $event.target)")
				.product-feed-offer-preview
					img.product-offer-picture(:src="offer.images && offer.images.length ? JSON.parse(offer.images)[0] : ''")
					.product-offer-title {{offer.title}}
					.i.fa.fa-times(@click="removeSelectedOffer(offer)")
				ProductFeedOffer(v-if="offer && expandedOfferId === offer.offer_id" :offer="offer" :setting="setting" v-pseudo-modal-name="'feed-offer-expanded-' + offer.offer_id")
			.product-feed-empty-offers(v-if="!settingValue.offers || !settingValue.offers.length")
				.product-offer-title There are no selected products
		.bottom-controls
			button.choose-products-button(v-on:click="chooseProducts")
				.download-icon Choose products
					.fa.fa-plus
			button.choose-products-button(v-on:click="addEmptyProduct")
				.download-icon Add empty product
					.fa.fa-plus
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import ProductFeedOffer		from './../../../components/Settings/CustomControls/ProductFeedOfffer';

	import { Project } 			from './../../../services/Project';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "ProductFeed",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Selected Version Settings Loaded", "Selected Version Settings Original Loaded"],
			events: {
				"Pseudo Modal Process Hide": function(names) {

					if (!_.find(names, n => n.indexOf('feed-offer-expanded-') === 0)) this.collapseOffer();

				}
			}
		},
		components: {
			ProductFeedOffer
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.settingValue = {};

			return {
				showed: true,
				expandedOfferId: false
			}

		},

		mounted() {

			// Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии проекта
			this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

		},

		methods: {
			collectData(event) {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('ProductFeed collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				if (event === 'mounted' || !this.expandedOfferId) {
					this.expandedOfferId = false;
				}

				this.settingValue = Settings.getSettingValue(this.setting.codename) || {};

				this.setting.value = this.settingValue;

			},
			setFeedUrl(url) {

				this.settingValue["feedUrl"] = url;

				this.$forceUpdate();

				this.delaySave();

			},
			removeSelectedOffer(offer) {
				let index = this.settingValue.offers.indexOf(offer);
				if (index > -1) {
					this.settingValue.offers.splice(index, 1);
					this.delaySave();
				}

			},
			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						SaveProductFeedOffers: {
							projectId: Project.SelectedProject.id,
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							feedUrl: this.settingValue.feedUrl,
							offers: this.settingValue.offers
						}
					});

				}, 200);

			},

			expandOffer(offerId, target) {
				if (target && target.classList.contains('fa-times')) return;
				this.expandedOfferId = offerId;
			},
			collapseOffer() {
				this.expandedOfferId = false;
			},
			chooseProducts() {

				Broadcast.call("Show ProductFeedChooser", [this.setting]);

			},
			addEmptyProduct() {

				let selectedOffers = [];
				if (this.settingValue && this.settingValue.offers) selectedOffers = this.settingValue.offers;

				const dateNow = Date.now();
				const offerId = dateNow - Math.floor(Math.random() * dateNow);

				let emptyOffer = {
					"id": offerId,
					"product_feed_id": 0,
					"offer_id": offerId,
					"category_codename": "0",
					"currency_codename": "RUB",
					"brand": "",
					"title": "New offer " + offerId,
					"description": "",
					"images": "",
					"price": 0,
					"is_available": 1,
					"url": "",
					"custom_offer": true
				}

				Server.sendToSocket({
					SaveProductFeedOffers: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						settingCodename: this.setting["codename"],
						offers: selectedOffers.concat([emptyOffer])
					}
				});


			}
		}
	}
</script>

<style lang="sass">

	.product-feed
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column
		//border: 1px solid #23282c
		//border-radius: 5px
		//background-color: #343b41

		.product-feed-url
			position: relative
			margin: 5px 0
			font-size: 12px

			.track-url-event-url

				.track-url-event-url-setting
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center
					padding-bottom: 10px

					&.track-multiple
						border-bottom: 1px solid #23282c
						margin-bottom: 10px

		.product-feed-offers
			margin: 5px 0
			display: flex
			flex-direction: column
			border: 1px solid #24282c
			border-radius: 5px
			background-color: #343b41

			&>*:not(:last-child)
				border-bottom: 1px solid #24282c

			.product-feed-offer

				&:hover
					background-color: #2f363c

				>.product-feed-offer-preview
					display: flex
					flex-direction: row
					gap: 5px
					height: 25px
					padding: 3px 5px 3px 3px
					cursor: pointer

					>.product-offer-title
						white-space: nowrap
						text-overflow: ellipsis
						overflow: hidden
						width: 100%

					>.product-offer-picture
						width: 22px
						min-width: 22px
						object-fit: contain

					>.i.fa.fa-times
						height: 14px
						margin: auto 0 auto 0
						cursor: pointer

						&:hover
							color: #ef7674

		.bottom-controls
			display: flex
			flex-direction: row
			justify-content: space-between

			.choose-products-button
				border: 1px solid #c8ced3
				border-radius: 0.25rem
				color: #c8ced3
				background-color: #3a4149
				margin: 5px 0
				padding: 3px

				&:hover
					color: #23282c
					background-color: #c8ced3
					border-color: #c8ced3

				.download-icon
					padding: 2px 5px

					.fa
						margin-left: 5px

</style>
